import config from '@/config';
import authLocal from './auth-local';
import authOauth from './auth-oauth';
import authAgcoCustomerPortal from './auth-agco_customer_portal';
import authAgcoDealerPortal from './auth-agco_dealer_portal';

function getAuthModule() {
  if (config.features.localAuth) return authLocal;
  if (config.features.oauthAuth) return authOauth();
  if (config.features.agcoCustomerPortalAuth) return authAgcoCustomerPortal();
  if (config.features.agcoDealerPortalAuth) return authAgcoDealerPortal();
  throw new Error('Not valid authentication mechanism has been set up.');
}

export default getAuthModule();
